import { useDispatch, useSelector } from "react-redux";
import "../manage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  removeBotime,
  setBotime,
  setBotimeOnEdit,
} from "../../Redux/Actions/botimeActions";

const ManageBotime = () => {
  const dispatch = useDispatch();
  const [botimet, setBotimet] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedUser = useSelector((state) => state.users.loggedUser);
  const isLoggedIn = Object.keys(loggedUser).length > 0;
  const navigate = useNavigate();

  if (!isLoggedIn) navigate("/login");

  useEffect(() => {
    const fetchBotime = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.arkiva.gov.al/api/botime?page=${currentPage}&limit=20`,
        );
        setBotimet(response.data.botime);
        setTotalPages(response.data.totalPages);
        dispatch(setBotime(response.data.botime));
      } catch (error) {
        console.error("Error fetching botime:", error);
      }
      setLoading(false);
    };

    if (isLoggedIn) {
      fetchBotime();
    } else {
      navigate("/login");
    }
  }, [dispatch, isLoggedIn, navigate, currentPage]);

  const editBotime = (botime) => {
    navigate(`/manage/botime/${botime._id}`);
    dispatch(setBotimeOnEdit(botime));
  };

  const addBotime = () => {
    navigate("/manage/botime/add-new");
  };

  const deleteBotime = async (botime) => {
    try {
      const response = await axios.delete(
        `https://api.arkiva.gov.al/api/botime/delete/${botime._id}`,
        { data: { id: botime.id } },
      );
      if (response.data.message === "error") {
        alert("Something went wrong!");
      } else {
        setBotimet((prevBotimet) =>
          prevBotimet.filter((item) => item._id !== response.data.botimeId),
        );
        dispatch(removeBotime(response.data.botimeId));
      }
    } catch (error) {
      console.error("Error deleting botime:", error);
    }
  };

  const filteredBotime = botimet.filter((item) =>
    (item.title || "").toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="manage-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button onClick={addBotime}>
            <i className="fa-solid fa-plus"></i> Shto botim
          </button>
        </div>
      </div>
      <div className="manage-table">
        <table className="table revista">
          <thead>
            <tr>
              <th>Titulli</th>
              <th>Autori</th>
              <th className="act">Veprime</th>
            </tr>
          </thead>
          <tbody>
            {filteredBotime.length > 0 ? (
              filteredBotime.map((item, index) => (
                <tr key={index}>
                  <td data-label="Title">{item.title}</td>
                  <td data-label="Author">{item.author}</td>
                  <td className="actions" data-label="Actions">
                    <button onClick={() => editBotime(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button onClick={() => deleteBotime(item)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">Nuk u gjetën botime!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <button
          className={`pagination-control-btn ${
            currentPage === 1 ? "disabled" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        >
          &#8592; Para
        </button>

        <span className="pagination-current-page">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className={`pagination-control-btn ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
        >
          Pas &#8594;
        </button>
      </div>
    </div>
  );
};

export default ManageBotime;
